import { Box } from '@mantine/core';
import { ConfigFieldValue } from '@/types/automationFields.ts';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import { ReactNode } from 'react';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import { IntegrationTextConfigField } from '@/types/integrations.ts';
import { getStringRightSectionProps } from '@/pages/Editor/components/SharedFields/IntegrationFields/IntegrationFieldTypes/getStringRightSectionProps.tsx';

type props = {
  stepId: string;

  field: IntegrationTextConfigField;
  fieldValue: any;
  fieldValueConfig: ConfigFieldValue;
  onChange: (updated_value: any) => void;
  rightSection?: ReactNode;
};

const TextInputField = ({
  stepId,
  field,
  fieldValue,
  fieldValueConfig,
  onChange,
  rightSection,
}: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);
  const rightSectionProps = getStringRightSectionProps(field.right_section_text || rightSection);

  return (
    <Box pos="relative">
      <StyledTextInput
        label={field.display_name}
        value={fieldValue ?? ''}
        description={field.description ?? undefined}
        placeholder={field.placeholder ?? undefined}
        onChange={(event) => onChange(event.currentTarget.value)}
        required={field.required}
        maxLength={field.max_length ?? undefined}
        error={error?.message}
        {...rightSectionProps}
        disabled={fieldValueConfig.is_disabled}
        readOnly={field.read_only}
      />
    </Box>
  );
};

export default TextInputField;
